import type { IIssueRepository, IssueListOptions } from '../repositories/IIssueRepository.js';
import type { IssueEntity } from '../entities/IssueEntity.js';

interface Deps { issueRepository: IIssueRepository; }

export function createListIssuesUseCase({ issueRepository }: Deps) {
  return async function listIssues(options: IssueListOptions): Promise<{ data: IssueEntity[]; total: number }> {
    return issueRepository.list(options);
  };
}
